/* ---------------------------------------------------------------------------
   motion.js — scroll-reveal choreography + count-up + watchdog.
   Port of the Claude design's motion.js pattern.
   No frameworks. Pure IntersectionObserver + setTimeout watchdog so content
   is never invisible if IO fails to fire (mobile Safari edge cases).
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var WATCHDOG_MS = 1200;

  function reveal(el) {
    if (!el || el.classList.contains('is-revealed')) return;
    var delay = parseInt(el.dataset.revealDelay || '0', 10) * 100;
    if (delay > 0) {
      setTimeout(function () { el.classList.add('is-revealed'); }, delay);
    } else {
      el.classList.add('is-revealed');
    }
  }

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function countUp(el) {
    if (!el || el.dataset.countUpDone === '1') return;
    el.dataset.countUpDone = '1';
    var raw = (el.dataset.countUp || el.textContent || '').replace(/[, ]/g, '');
    var target = parseFloat(raw);
    if (!isFinite(target) || target === 0) { return; }
    var decimals = (raw.split('.')[1] || '').length;
    var duration = 1400;
    var start = performance.now();
    function tick(now) {
      var p = Math.min(1, (now - start) / duration);
      var v = target * easeOutCubic(p);
      var display = decimals > 0 ? v.toFixed(decimals) : Math.round(v).toLocaleString();
      el.textContent = display;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = decimals > 0 ? target.toFixed(decimals) : Math.round(target).toLocaleString();
    }
    requestAnimationFrame(tick);
  }

  function initReveals() {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    nodes.forEach(function (n) { io.observe(n); });

    // Watchdog: any node still hidden after WATCHDOG_MS gets forced revealed
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(reveal);
    }, WATCHDOG_MS);
  }

  function initCountUps() {
    var nodes = document.querySelectorAll('[data-count-up]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(countUp);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          countUp(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });

    // Watchdog
    setTimeout(function () {
      document.querySelectorAll('[data-count-up]').forEach(function (n) {
        if (n.dataset.countUpDone !== '1') countUp(n);
      });
    }, WATCHDOG_MS + 600);
  }

  function init() {
    initReveals();
    initCountUps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
